import actions from './actions';

const { selectCategory } = actions;

export default {
    selectCategory
};
